module.exports = __webpack_public_path__ + "src/assets/textures/petri/bunsen_burner_lambert3_AO.jpg";